﻿import $ from 'jquery';
import Url from "../utilities/url";

export class BrowserHistory {
  public static get wireup(): string { return '[data-query-parameter]'; }

  private $queryParameters: JQuery;
  private queryString: string;
  private title: string;

  public constructor($queryParameters) {
    if ($queryParameters.length <= 0)
      throw new Error("$queryParameters cannot be null");

    this.$queryParameters = $queryParameters;
    this.queryString = this.createQueryString();
    this.title = $('title').text();

  }

  private recordState() {
    $(window).off('popstate.rustig.browserhistory')

    let currentState = history.state || {};
    if (!currentState._querystring || this.queryStringsMatch(currentState._querystring))
      window.history.replaceState({ _querystring: this.queryString }, this.title, this.queryString)
    else
      window.history.pushState({ _querystring: this.queryString }, this.title, this.queryString);

    $(window).on('popstate.rustig.browserhistory', $.proxy(this.onStateChange, this));
  }

  private onStateChange(event) {
    let currentState = history.state;

    let shouldIgnoreStateChange = this.queryStringsMatch(currentState._querystring);
    if (!shouldIgnoreStateChange)
      window.location.href = currentState._querystring;
  }

  private queryStringsMatch(queryString: string): boolean {
    return this.queryString === queryString;
  }

  private createQueryString(): string {
    let url = new Url();

    this.$queryParameters.each(function () {
      let $element = $(this);

      let value = $element.val() as string;
      if ($element.data('is-bool'))
        value = value.toLowerCase();

      url.setQueryParameter($element.attr('name'), value);
    });

    return url.toUrl();
  }

  public static createHistory(): BrowserHistory {
    if (this.length <= 0)
      return;

    let $queryParameters = $('[data-query-parameter]');
    let h = new BrowserHistory($queryParameters);
    h.recordState();

    return h;
  }
}
